import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Content } from './Content';
import * as S from './styles';

export function InfoTooltip() {
	return (
		<S.CustomTooltip showArrow={false} title={<Content />} getPopupContainer={(triggerNode) => triggerNode}>
			<InfoCircleOutlined />
		</S.CustomTooltip>
	);
}
